<template>
	<div style="height: 100%">
		<LeftNavBar :title="selectedAppInitial" :items="navItems" @opened="onNavClick"
			:selectedValue="selectedNavItem" />
	</div>
</template>

<script>
import LeftNavBar from 'bh-mod/components/common/LeftNavBar'

export default {
	name: 'menu-left',
	components: { LeftNavBar },
	computed: {
		selectedAppInitial() {
			return this.$store.state.theApp?.media?.initial || 'FC'
		},
		isHighrise() {
			return this.$store.state.instance.productType === 'highrise';
		},
		isLowrise() {
			return this.$store.state.instance.productType === 'lowrise';
		},
		navItems() {
			const items = [];

			if (this.isLowrise) {
				items.push({ label: 'Exterior Color Packages', value: 'brick', iconUrl: require('@/assets/sideIcons/brick.svg') });
			}

			items.push({ label: 'Features & Finishes', value: 'features', iconUrl: require('@/assets/sideIcons/features.svg') });

			if (this.isHighrise) {
				items.push({ label: 'Building Amenities', value: 'buildingAmenities', iconUrl: require('@/assets/sideIcons/buildingAmenities.svg') });
				items.push({ label: 'Building Images', value: 'buildingImages', iconUrl: require('@/assets/sideIcons/buildingImages.svg') });
			}

			return items;
		},
		selectedNavItem() {
			const routes = {
				'/': 'brick',
				'/features': 'features',
				'/buildingAmenities': 'buildingAmenities',
				'/buildingImages': 'buildingImages',
			};

			return routes[this.$route.path] || '';
		},
	},
	methods: {
		onNavClick(e) {
			const routes = {
				brick: '/',
				features: '/features',
				buildingAmenities: '/buildingAmenities',
				buildingImages: '/buildingImages',
			};
			const targetPath = routes[e.value];
			if (targetPath && this.$route.path !== targetPath) {
				this.$router.push(targetPath);
			}
		},
	},
};
</script>
